import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import Indent from './Indent';

function TopIndent({ theme }) {
  const { indents } = theme.layout;

  return <Indent top={indents.top} />;
}

TopIndent.propTypes = {
  /** @ignore */
  theme: themePropTypes(`{
    layout: {
      indents: {
        top,
      }
    },
  }`),
};

const TopIndentWithHOC = withTheme(TopIndent);
TopIndentWithHOC.displayName = 'TopIndent';

export default TopIndentWithHOC;
